/*
 * Goloka V3 — page-to-page motion (6 Oct 2026).
 *
 * 1. Browsers with cross-document View Transitions (Chrome/Edge 126+, Safari
 *    18.2+): the page cross-fades and rises; the header stays put; and a
 *    product photo clicked in any grid MORPHS into the product page's main
 *    image (shared-element transition, via view-transition-name set on click).
 * 2. Other browsers: the page fades out on link click and the next page
 *    fades in with its sections staggered.
 * 3. Everywhere: a thin wine progress bar while the next page loads, and the
 *    first screen's sections rise in one after another on arrival.
 * Respects prefers-reduced-motion (does nothing). Skips new-tab clicks,
 * downloads, hash links, other origins, checkout and cart-drawer triggers.
 */
(function () {
  // Never inside the theme editor: its preview must control navigation itself.
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var html = document.documentElement;
  var hasVT = 'onpagereveal' in window && CSS.supports && CSS.supports('view-transition-name: none');
  var KEY = 'v3-vt-product';

  // ---- progress bar --------------------------------------------------------
  var bar = document.createElement('div');
  bar.className = 'v3-pbar';
  bar.setAttribute('aria-hidden', 'true');
  document.addEventListener('DOMContentLoaded', function () { document.body.appendChild(bar); });

  function eligible(a, e) {
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
    if (a.target && a.target !== '_self') return false;
    if (a.hasAttribute('download') || a.getAttribute('aria-haspopup') || a.id === 'cart-icon-bubble') return false;
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(href)) return false;
    var url;
    try { url = new URL(a.href, location.href); } catch (_) { return false; }
    if (url.origin !== location.origin) return false;
    if (/\/(checkout|checkouts|cart\/(add|change|clear))/.test(url.pathname)) return false;
    if (url.pathname === location.pathname && url.search === location.search && url.hash) return false;
    return true;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!eligible(a, e)) return;
    bar.classList.remove('is-done'); void bar.offsetWidth; bar.classList.add('is-loading');

    // Shared element: the clicked product photo becomes the next page's hero.
    var card = a.closest('.v3-card, .card-wrapper, [class*="v3-card"], .v3s__row, .v3h__best-link');
    var img = card && card.querySelector('img');
    if (img && /\/products\//.test(a.href)) {
      try { sessionStorage.setItem(KEY, '1'); } catch (_) {}
      if (hasVT) img.style.viewTransitionName = 'v3-product-image';
    } else {
      try { sessionStorage.removeItem(KEY); } catch (_) {}
    }

    if (!hasVT) {
      e.preventDefault();
      html.classList.add('v3-leaving');
      setTimeout(function () { location.href = a.href; }, 170);
    }
  }, true);

  // Back/forward cache restores a faded page — undo.
  window.addEventListener('pageshow', function () {
    html.classList.remove('v3-leaving');
    bar.classList.remove('is-loading'); bar.classList.add('is-done');
  });

  // Incoming product page: name its main image so the morph lands on it.
  if (hasVT) {
    window.addEventListener('pagereveal', function (e) {
      var morph = false;
      try { morph = sessionStorage.getItem(KEY) === '1'; sessionStorage.removeItem(KEY); } catch (_) {}
      if (!e.viewTransition || !morph) return;
      var hero = document.querySelector('.product__media-item.is-active img, .product__media-list img, .product-media-container img');
      if (!hero) return;
      hero.style.viewTransitionName = 'v3-product-image';
      e.viewTransition.finished.finally(function () { hero.style.viewTransitionName = ''; });
    });
  }

  // ---- arrival: stagger the first screen ----------------------------------
  function arrive() {
    html.classList.add('v3-arrive');
    var secs = document.querySelectorAll('#MainContent > .shopify-section');
    var i = 0;
    secs.forEach(function (s) {
      var r = s.getBoundingClientRect();
      if (r.top < innerHeight * 1.05 && i < 5) { s.style.setProperty('--v3-arrive-delay', (i * 70) + 'ms'); s.classList.add('v3-arrive-sec'); i++; }
    });
    setTimeout(function () { html.classList.remove('v3-arrive'); }, 1100);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrive); else arrive();
})();
